import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Summary_Scoreless_Header({ item, isSub }) {
  return (
    <Row className={"mb-3 mx-0"} style={{ marginTop: "30px" }}>
      <div className="summary-scaleless-container-wrap-up">
        <Row className="justify-content-center">
          <Col
            xs={"auto"}
            style={{ fontSize: "34px" }}
            className={`align-content-center pt-0 ${isSub ? "detail-section-sub-scope-name-header-wrap-up" : "detail-section-scope-name-header-wrap-up"}`}
          >
            {item.name}
          </Col>
        </Row>
      </div>
    </Row>
  );
}
